import React from 'react';
import { Routes } from 'services/route';
import { authRoutes } from './auth-routes';
import { AuthGuard } from 'services/auth';
import { NormalLayout } from 'components/layout';
import { UserPermissionGuard } from 'services/user-permission/user-permission.guard';
import { chatRoutes } from './chat-routes';
import ChatLayout from 'pages/chat/layout';

export const appRoutes: Routes = [
  {
    path: 'auth',
    children: authRoutes,
  },
  {
    path: 'forbidden',
    component: React.lazy(() => import('pages/auth/forbidden')),
  },
  {
    path: 'chat',
    middleware: [AuthGuard],
    component: ChatLayout,
    children: chatRoutes,
  },
  {
    path: '',
    middleware: [AuthGuard, UserPermissionGuard],
    component: NormalLayout,
    children: [
      {
        path: '',
        component: React.lazy(() => import('pages/home-page')),
      },
      {
        path: 'home',
        component: React.lazy(() => import('pages/home/home.component')),
      },
      {
        path: 'dashboard',
        component: React.lazy(() => import('pages/dashboard/dashboard.component')),
      },
      {
        path: 'form-sample',
        component: React.lazy(() => import('pages/form-sample/form-sample.component')),
      },
      {
        path: 'cv',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/cv')),
          },
          {
            path: 'add',
            component: React.lazy(() => import('pages/cv/add')),
          },
          {
            path: 'edit/:cvId/:historyId',
            component: React.lazy(() => import('pages/cv/edit')),
          },
          {
            path: 'detail',
            component: React.lazy(() => import('pages/cv/detail')),
          },
          {
            path: 'approve/true/:cvId',
            component: React.lazy(() => import('pages/cv/list/block')),
          },
          {
            path: 'approve/false/:cvId',
            component: React.lazy(() => import('pages/cv/list/block')),
          },
          {
            path: ':partnerId',
            component: React.lazy(() => import('pages/cv/list/block')),
          },
          {
            path: ':statusCv/:partnerId',
            component: React.lazy(() => import('pages/cv/list/block')),
          },
        ],
      },

      {
        path: 'user',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/user/list')),
          },
          {
            path: 'user-profile',
            component: React.lazy(() => import('pages/user/user-profile')),
          },
        ],
      },
      {
        path: 'doc',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/document/index')),
          },
          {
            path: 'add',
            component: React.lazy(() => import('pages/document/add')),
          },
          {
            path: 'edit/:id',
            component: React.lazy(() => import('pages/document/edit')),
          },
          {
            path: 'detail',
            component: React.lazy(() => import('pages/document/detail')),
          },
        ],
      },
      {
        path: 'job',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/job/index')),
          },
        ],
      },
      {
        path: 'task',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/task-ton/index')),
          },
        ],
      },
      {
        path: 'company',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/company/index')),
          },
          {
            path: 'add',
            component: React.lazy(() => import('pages/company/add')),
          },
          {
            path: 'edit/:id',
            component: React.lazy(() => import('pages/company/edit')),
          },
        ],
      },
      {
        path: 'role',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/role/list')),
          },
        ],
      },
      {
        path: 'user-cv',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/user-cv/list')),
          },
        ],
      },
      {
        path: 'paragraph-chat',
        children: [
          {
            path: ':type',
            component: React.lazy(() => import('pages/paragraph-chat/index')),
          },
        ],
      },

      {
        path: 'turnovers',
        children: [
          {
            path: '',
            component: React.lazy(() => import('pages/turnovers/index')),
          },
        ],
      },
      {
        path: 'setting',
        children: [
          {
            path: 'general',
            component: React.lazy(() => import('pages/settings/general/index')),
          },
          {
            path: ':type',
            component: React.lazy(() => import('pages/settings/list')),
          },
          {
            path: 'kpi/:kpi',
            component: React.lazy(() => import('pages/settings/kpi/index')),
          },
        ],
      },
      {
        path: 'kpi',
        children: [
          {
            path: 'sale',
            component: React.lazy(() => import('pages/kpi/index')),
          },
          {
            path: 'recer',
            component: React.lazy(() => import('pages/kpi/index')),
          },
          {
            path: 'sale/detail/:userId',
            component: React.lazy(() => import('pages/kpi/index')),
          },
          {
            path: 'recer/detail/:userId',
            component: React.lazy(() => import('pages/kpi/index')),
          },
        ],
      },

    ],
  },
];
